<template>
  <div>
    <Pagination :table-collection="blacklistCollection" sorting-field="blockDate" range-field="date">
      <template slot-scope="props">
        <b-table-column :label="$t('date')">
          {{ props.row.blockDate.toDate().toLocaleDateString() }}
        </b-table-column>
        <b-table-column :label="$t('vatId')">
          {{ props.row.vatId }}
        </b-table-column>
        <b-table-column :label="$t('legalName')">
          {{ props.row.legalName }}
        </b-table-column>
        <b-table-column :label="$t('delete')">
          <b-button type="is-small is-danger ml-2" icon-right="delete" @click="deleteBlacklistEntry(props.row.id)" />
        </b-table-column>
      </template>
      <template slot="top-left">
        <b-button type="is-primary" :label="$t('addCompany')" icon-left="plus" @click="addToBlacklist" />
      </template>
    </Pagination>
    <b-modal
      :active.sync="blacklistModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <BlacklistModal :blacklist-collection="blacklistCollection" />
    </b-modal>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import BlacklistModal from "@/components/BlacklistModal";

export default {
  name: "BlacklistTable",
  components: {
    Pagination,
    BlacklistModal,
  },
  props: {
    blacklistCollection: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      blacklistModalActive: false,
    };
  },
  methods: {
    addToBlacklist() {
      this.blacklistModalActive = true;
    },
    async deleteBlacklistEntry(id) {
      await this.blacklistCollection.doc(id).delete();
    },
  },
};
</script>

<style>
.table {
  width: 100%;
}
.pagination .info {
  display: none;
}
</style>
